import '@main';

const timerEls: HTMLDivElement[] = u.selectAll('.j-out-date-timer');

timerEls.forEach((el) => {
  if (el.dataset.time) {
    el.style.display = 'block';

    let countDownDate = new Date(el.dataset.time).getTime();

    let timer = setInterval(function() {
      let now = new Date().getTime();
      let distance = countDownDate - now;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

      el.innerHTML = u.trans('app.film.out.date', days, hours, minutes);

      if (distance < 0) {
        clearInterval(timer);
        el.style.display = 'none';
      }
    }, 1000);
  }
})
